import { render, staticRenderFns } from "./InputOtp.vue?vue&type=template&id=66f37723&"
import script from "./InputOtp.vue?vue&type=script&lang=js&"
export * from "./InputOtp.vue?vue&type=script&lang=js&"
import style0 from "./InputOtp.vue?vue&type=style&index=0&id=66f37723&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports